import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=6ccfa1ed&scoped=true&"
import script from "./HeaderCart.vue?vue&type=script&lang=ts&"
export * from "./HeaderCart.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderCart.vue?vue&type=style&index=0&id=6ccfa1ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfa1ed",
  null
  
)

export default component.exports